var Backbone = require('backbone'),
    BasePage = require('./basePg'),
    DocModePage = require('./pgDocMode'),
    fvChannel = require('glRadio').channel('FV');


/**
 * Should have all notes collection or mediate fns w/vChannel.
 * TODO:
 * - everything 'renderable GOS' could be removed from here (anything involving originalImageProperties) and subclassed for clarity (?)
 * - also subclassing of the page types would make more flex and maintanable ...
 */



var DEFAULT_COLD_OVERLAY_DIMENSIONS = {
    width: 8.5,
    height: 11
};

module.exports = BasePage.extend({

    typeIdentifier: 'PG_MODE',
    SPIN_JS_OPTS: { top: '40px', left: '60px', length: 6, radius: 6, width: 2, lines: 13 },
    nonRenderableOrigDimensions: BasePage.prototype.STANDARD_PG_DIMS,
    defaults: _.omit( DocModePage.prototype.defaults, 'vOffset)' ),

    parse: function( pageAttrs, options ) {

        pageAttrs = _.clone(pageAttrs);

        /**
         * If COLD: convert original image properties from inches to pixels -- adjusting the original,
         *  -- essentially indicating this has known dimensions  -- that of the paper.
         * But now with the default overlay page dimensions set at 0x0, in a sense this also has 'unknown' dimensions ( below ).
         */
        if ( this._pageTypeIsCold(pageAttrs.pageType) ) {

            // Set the derived attributes differently.
            // Note: these will change on load.
            var dpi = fvChannel.request('settings').DPI;
            var paperWidth = pageAttrs.overlay.paperWidth;
            var paperHeight = pageAttrs.overlay.paperHeight;


            /**
             *  DVBC-1820: handling 0 x 0 page sizes -- to temporary allow for a loading 'placeholder'.
             *  Ideally would want to set immediately to the 'derived' size that it will become,
             *  which can be determined when we get the text; however, we can't introduce
             *  something asynchronous into this WF.
             *  If needed, could put a flag on the here or the doc mode model.
             *  Initially only did if there was no image overlay, but not longer -- do for both.
             *  If there is an image overlay, the paper size will be set according to the the derived text dimensions --
             *  this is different behavior than FDD, which wouldn't show the image.  If we want to do that,
             *  we shouldn't request the image at all and create a different WF.
             *  If there is not an overlay, it will be set according to FDD's logic,
             *  which would also set to the derived text dimensions since the derived text would always exceed the bounds.
             */

            if (paperWidth === 0) {
                paperWidth = DEFAULT_COLD_OVERLAY_DIMENSIONS.width;
            }

            if (paperHeight === 0) {
                paperHeight = DEFAULT_COLD_OVERLAY_DIMENSIONS.height;
            }


            var derivedAttrs = {
                width: paperWidth * dpi,
                height: paperHeight * dpi,
                isRenderable: true,
                parentDocument: options.parentDocument,
                imageFileType: options.imageFileType
            };


            return _.extend (pageAttrs, derivedAttrs );

        } else {

            /* normal not cold */

            return  _.omit( BasePage.prototype.parse.apply(this,arguments), 'vOffset' );
        }

    },


    /**
     * TODO: don't call this 'setWidth', here it's dynamic (???)
     */
    _getSetWidth: function( attrs, isRenderable ) {

        if (!isRenderable)
            return this.nonRenderableOrigDimensions.w;

        return attrs.originalImageProperties
            ? attrs.originalImageProperties.width
            : this.unknownOrigDimsDimensions.w;

    },

    /**
     * Really the derived height from the original width of the image and that width of it's container
     * Now same as docMode except we don't adjust for container size ...
     * TODO: here height is now not dervied from width ...
     */
    _getHeightDerivedFromWidth: function( attrs, isRenderable ) {

        // Note: this top part is resuable with pgDocMode
        if (!isRenderable)
            return this.nonRenderableOrigDimensions.h;

        return attrs.originalImageProperties
            ? attrs.originalImageProperties.height
            : this.unknownOrigDimsDimensions.h;


    },

    getImgRenderRequest: function() {

        // Now loading GOS in full page mode as PDFs inside iframes
        // I think image parameters are on here unecessarily, should probably
        // change that on nonImgRenderRequest, but don't want to break anything

        if ( this.isGOS() ) {
            var req = BasePage.prototype.nonImgRenderRequest.apply(this, ['pdf', 'pdf']);
            return req;
        }

        // Same as the request from base but without the width parameter
        var request = BasePage.prototype.getImgRenderRequest.call(this);
        delete request.renderRequest.renderingParameters.imageParameters;
        return request;
    },

    /* In this mode COLD page dimensions are known and defined from the 'paper' ( above ) */
    resizePageFromDummyDimensionsPostLoad: function() {

        if ( this.isCold() )
            return false;

        return BasePage.prototype.resizePageFromDummyDimensionsPostLoad.apply( this, arguments );

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/page/pgFullSize.js
 ** module id = 268
 ** module chunks = 0
 **/